import React from 'react'

function Terms() {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>Terms of Service for Stock and Inventory Management</h1>

      <h2>1. Introduction</h2>
      <p>
        These Terms & Conditions (“Agreement”) govern your use of Inventory ERP. 
        By signing up, you agree to comply with these terms.
      </p>

      <h2>2. User Responsibilities</h2>
      <ul>
        <li>Users must provide accurate business and personal details.</li>
        <li>Sharing login credentials is strictly prohibited.</li>
        <li>Users must not misuse or exploit the platform for illegal activities.</li>
        <li>Each client is responsible for maintaining their own stock & order records.</li>
      </ul>

      <h2>3. Subscription & Payments</h2>
      <ul>
        <li>Users must subscribe to one of our plans.</li>
        <li>Payments are collected via Razorpay / Stripe / PayPal (based on your setup).</li>
        <li>Failure to renew the subscription will result in account suspension after [X] days.</li>
        <li><strong>Refund Policy:</strong> No refunds once a subscription is active.</li>
      </ul>

      <h2>4. Account Suspension & Termination</h2>
      <ul>
        <li>We reserve the right to suspend any account found violating these terms.</li>
        <li>Repeated violations may lead to permanent account termination.</li>
        <li>Users can request account deletion at any time.</li>
      </ul>

      <h2>5. Limitation of Liability</h2>
      <p>We are not liable for:</p>
      <ul>
        <li>Losses due to incorrect stock tracking or order processing.</li>
        <li>Business disruptions due to server downtime (we ensure 99.9% uptime).</li>
        <li>Unauthorized access caused by weak user passwords.</li>
      </ul>

      <h2>6. Modifications to Terms</h2>
      <p>
        We may update these Terms occasionally. Continued use of the platform implies acceptance of changes.
      </p>

      <h2>Business Alerts and Reorder Policies</h2>
      <p><strong>For any legal queries:</strong> contact <a href="mailto:support@clearbiz.ai">support@clearbiz.ai</a></p>
    </div>
  )
}

export default Terms
